{
  "fr": {
    "editor_ziggu": {
      "actions": {
        "apply": "Appliquer",
        "cancel": "Annuler",
        "link": "Lien",
        "showLess": "Montrer moins",
        "showMore": "Montrer plus"
      },
      "labels": {
        "blue": "Bleu",
        "green": "Vert",
        "link_text": "Texte du lien",
        "orange": "Orange",
        "pink": "Rose",
        "purple": "Pourpre",
        "red": "Rouge",
        "remove_highlight": "Supprimer la surbrillance",
        "yellow": "Jaune"
      },
      "placeholders": {
        "content": "Commencer à écrire..",
        "link": "Taper / coller un lien"
      }
    }
  }
}